<big-ui-modal-frame
    *transloco="let t; prefix: 'uiModalEmbedded'"
    [closeBtnTitle]="t('close')"
    (closeModal)="popoverRef.close()"
    [contentClass]="'overflow-auto'"
    [slimHeader]="true">
    <ng-container title>{{ label }}</ng-container>
    <ng-container content>
        @if (isImage && url) {
            <img
                [src]="url"
                [alt]="label"
                class="object-contain w-full h-full" />
        } @else {
            @if (url) {
                <embed
                    [src]="url | sanitize: securityContext"
                    class="max-w-full max-h-full"
                    [height]="viewPortSize().height"
                    [width]="viewPortSize().width" />
            }
        }
    </ng-container>
    <ng-container buttonBar>
        <big-ui-button
            [buttonStyle]="'primary'"
            [id]="'close-overlay-btn'"
            (clicked)="popoverRef.close()"
            [title]="t('close')">
            <span>{{ t('close') }}</span>
        </big-ui-button>
    </ng-container>
</big-ui-modal-frame>
>
